export const LANDING = '/';
export const LOGGEDIN = '/app';
export const LOGIN = '/login';
export const EVENTS = '/app/events';